import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(18, 34, 67, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  direction: rtl;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContent = styled.div`
  background: ${colors.white};
  border-radius: 20px;
  padding: 32px;
  max-width: 400px;
  width: 100%;
  position: relative;
  box-shadow: 0 20px 40px rgba(18, 34, 67, 0.3);
  animation: slideUp 0.3s ease-out;
  text-align: center;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @media (max-width: 768px) {
    padding: 24px;
    max-width: 90%;
  }
`;

export const ModalTitle = styled.h2`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: ${colors.darkBlue};
  margin: 0 0 12px 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 10px;
  }
`;

export const ModalDescription = styled.p`
  font-family: "Noto Sans Hebrew", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.blueGray};
  margin: 0 0 24px 0;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 20px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  direction: rtl;

  @media (max-width: 480px) {
    flex-direction: column-reverse;
    gap: 10px;
  }
`;

export const CancelButton = styled.button`
  background: ${colors.lightGray};
  border: 2px solid ${colors.lightGray};
  color: ${colors.darkBlue};
  padding: 8px 24px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: "Noto Sans Hebrew", sans-serif;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 100px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${colors.blueGray};
    border-color: ${colors.blueGray};
    color: ${colors.white};
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(126, 138, 173, 0.2);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  @media (max-width: 480px) {
    width: 100%;
    min-width: auto;
  }
`;

export const DeleteButton = styled.button`
  background: #d32f2f;
  border: 2px solid #d32f2f;
  color: ${colors.white};
  padding: 8px 24px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: "Noto Sans Hebrew", sans-serif;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 100px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #b71c1c;
    border-color: #b71c1c;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(211, 47, 47, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  @media (max-width: 480px) {
    width: 100%;
    min-width: auto;
  }
`;
